import type { SectionKit } from './kit';

/** Top bar: the logo (or a text wordmark), a few in-page links on desktop, and
 *  one small button. Links point at section anchors (`#pricing`) or URLs; on
 *  phones only the brand and the button show, so the bar never wraps. */
export default function NavBlock({ k }: { k: SectionKit }) {
  const { section, s, theme, btnBg, onBtn, txt, link, editable } = k;
  const links = (section.links ?? []).filter((l) => l.label);
  const logo = section.logo !== false && theme.logo_url
    ? <img src={theme.logo_url} alt="" loading="eager" decoding="async" className="h-8 w-auto max-w-[160px] object-contain" />
    : null;
  // Editor canvas: with no logo and no name, the name slot shows a placeholder.
  const word = !logo && (section.heading || editable)
    ? <span className={`truncate text-[17px] leading-none ${s.heading}`}>{txt(section.heading ?? '', (t) => ({ heading: t }), false, 'Add your brand')}</span>
    : null;
  return (
    <nav className="flex min-h-10 items-center justify-between gap-4" aria-label="Page">
      <div className="flex min-w-0 items-center gap-2">{logo ?? word}</div>
      {links.length > 0 && (
        <div className="hidden items-center gap-7 md:flex">
          {links.map((l, i) => (
            <a key={i} href={l.href || '#'} target={(l.href || '#').startsWith('#') ? undefined : '_blank'} rel="noopener noreferrer"
              className={`text-sm font-medium transition-opacity hover:opacity-70 ${s.sub}`}>{l.label}</a>
          ))}
        </div>
      )}
      {section.label
        ? link(section.label, section.href || '#form', `inline-grid shrink-0 place-items-center whitespace-nowrap px-4 py-2 text-sm ${s.button}`, { background: btnBg, color: onBtn })
        : <span className="hidden md:block" />}
    </nav>
  );
}
